// Services
import callAPI from "../callApi";
import path from "../variables";

const AutoPack = {
	vehicles: {
		getAll: (filter?: any) =>
			callAPI(
				"GET",
				`${path.base}/automobile/vehicles${filter ? filter : ""}`,
				"",
				"getting all vehicles"
			),
		create: (data: any) =>
			callAPI("POST", `${path.base}/automobile/vehicles`, data, "creating new vehicle"),
	},
	vehiclesType: {
		getAll: () =>
			callAPI("GET", `${path.base}/automobile/vehicles/vtypes`, "", "getting all vehicle types"),
		create: (data: any) =>
			callAPI("POST", `${path.base}/automobile/vehicles/vtypes`, data, "creating new vehicle type"),
		update: (uuid: string, data: any) =>
			callAPI("PUT", `${path.base}/automobile/vehicles/vtypes/${uuid}`, data, "updating vehicle type"),
		delete: (uuid: string) =>
			callAPI("DEL", `${path.base}/automobile/vehicles/vtypes/${uuid}`, "", "deleting vehicle type"),
	},
	technicalVisit: {
		getAll: () =>
			callAPI("GET", `${path.base}/automobile/technicalvisits`, "", "getting all technical visits"),
		create: (data: any) =>
			callAPI(
				"POST",
				`${path.base}/automobile/technicalvisits`,
				data,
				"creating new technical visits entry"
			),
	},
	technicalVisitStatus: {
		getAll: () =>
			callAPI(
				"GET",
				`${path.base}/automobile/technicalvisitstatus`,
				"",
				"getting all technical visits statuses"
			),
		create: (data: any) =>
			callAPI(
				"POST",
				`${path.base}/automobile/technicalvisitstatus`,
				data,
				"creating new technical visits status entry"
			),
	},
	maintenance: {
		getAll: () =>
			callAPI("GET", `${path.base}/automobile/maintenances`, "", "getting all maintenances"),
		create: (data: any) =>
			callAPI(
				"POST",
				`${path.base}/automobile/maintenances`,
				data,
				"creating new maintenance entry"
			),
		update: (id: string | number, data: any) =>
			callAPI("PUT", `${path.base}/automobile/maintenances/${id}`, data, "updating maintenance"),
		delete: (id: string | number) =>
			callAPI("DEL", `${path.base}/automobile/maintenances/${id}`, "", "deleting maintenance"),
	},
	garages: {
		getAll: () =>
			callAPI("GET", `${path.base}/automobile/garages`, "", "getting all garages"),
		create: (data: any) =>
			callAPI("POST", `${path.base}/automobile/garages`, data, "creating new garage"),
	},
	insurance: {
		getAll: (filter?: any) =>
			callAPI("GET", `${path.base}/automobile/insurances${filter ?? ""}`, "", "getting all insurances"),
		create: (data: any) =>
			callAPI("POST", `${path.base}/automobile/insurances`, data, "creating new insurance entry"),
		delete: (uuid: string) =>
			callAPI("DELETE", `${path.base}/automobile/insurances/${uuid}`, "", "deleting insurance"),
	},
	beverage: {
		getAll: () => callAPI("GET", `${path.base}/automobile/beverages`, "", "getting all beverages"),
		create: (data: any) =>
			callAPI("POST", `${path.base}/automobile/beverages`, data, "creating new beverage entry"),
	},
	vehicleTax: {
		getAll: () => callAPI("GET", `${path.base}/automobile/vehicletaxes`, "", "getting all vehicle taxes"),
		create: (data: any) => callAPI("POST", `${path.base}/automobile/vehicletaxes`, data, "creating new vehicle tax"),
	},
	vehicleSale: {
		getAll: () => callAPI("GET", `${path.base}/automobile/vehiclesales`, "", "getting all vehicle sales"),
		create: (data: any) => callAPI("POST", `${path.base}/automobile/vehiclesales`, data, "creating new vehicle sale"),
	},
	vehicleRental: {
		getAll: () => callAPI("GET", `${path.base}/automobile/vehiclerentals`, "", "getting all vehicle rentals"),
		create: (data: any) => callAPI("POST", `${path.base}/automobile/vehiclerentals`, data, "creating new vehicle rental"),
	},
};

export default AutoPack;
